import { useAuth0 } from "@auth0/auth0-react";
import { Alert, Box, CircularProgress } from "@mui/material";
import createClient from "openapi-fetch";
import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router";
import { useFlags } from "../../server/optimizely";
import { serviceURL } from "../../utils/service-url";

import type { paths } from "../../__definitions__/key.changeengine.com-definitions";
import type { FC } from "react";

const ProductPortalRedirect: FC = () => {
  const {
    flags: { product_portal },
    flagsLoaded,
  } = useFlags("product_portal");
  const { "*": path } = useParams();
  const [displayError, setDisplayError] = useState<string>();
  const { getAccessTokenSilently } = useAuth0();
  useEffect(() => {
    if (!product_portal) return;
    void (async () => {
      const accessToken = await getAccessTokenSilently();
      const key = createClient<paths>({
        baseUrl: serviceURL("key"),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const { data, error } = await key.POST("/portal", { body: {} });
      if (error) setDisplayError(error.error);
      if (data) {
        const url = new URL(`/${path ?? ""}`, "https://product.changeengine.com");
        url.searchParams.set("token", data.key);
        globalThis.location.replace(url);
      }
    })();
  }, [getAccessTokenSilently, path, product_portal]);

  if (flagsLoaded && !product_portal) return <Navigate replace to="/" />;
  if (displayError) return <Alert severity="error">{displayError}</Alert>;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default ProductPortalRedirect;
